export const getUppercaseClass = (uppercase: boolean = true): string => {
  return uppercase ? 'uppercase' : '';
};

export const badgeVariants: Record<string, string> = {
  cream: 'bg-yellow-0 text-yellow-300',
  'forest-green': 'bg-green-0 text-green-300',
  'abyssal-blue': 'bg-light-blue text-blue-whale',
  'blood-red': 'bg-red-0 text-red-300',
  'ice-blue': 'bg-brand-100 text-brand-700',
  graphite: 'bg-neutral-0 text-neutral-600',
};

export const sizeClasses: Record<string, string> = {
  small: 'text-xs py-1 px-2',
  medium: 'text-sm py-2 px-3',
  large: 'text-base py-3 px-4',
};
